import React, { useState } from "react";
import "./RequestInfo.css";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import BaseModal from "./baseModal/BaseModal";
import { BLUE_BUTTON, RED_BUTTON } from "./baseModal/colours";
import { Icon } from "semantic-ui-react";
import {
  STRING_INPUT,
  TITLE,
  GET_HTML,
  TEXT_AREA,
  DROPDOWN
} from "./baseModal/FieldTypes";
//NOT USED
const NewAutomationModal = ({ onSubmit, onClose, templates, editAutomation }) => {
  const [communicationType, setCommunicationType] = useState(editAutomation?.communicationType || "");
  const [automationType, setAutomationType] = useState(editAutomation?.automationType || "");
  const [template, setTemplate] = useState(editAutomation?.templateId || "");
  const [timing, setTiming] = useState(editAutomation?.timing || "");
  const [timingUnit, setTimingUnit] = useState(editAutomation?.timingUnit || "Days");
  const [automationFor, setAutomationFor] = useState(editAutomation?.automationFor || "");
  
  const validateTiming = (value) => {
    if (!Number.isInteger(Number(value)) || Number(value) <= 0) {
      toast.error("Timing must be a whole number greater than 0");
      return false;
    }
    return true;
  };

  const getAvailableTypes = (automationFor) => {
    const types = [];
    
    if (['Programs', 'Online', 'Events', 'Memberships'].includes(automationFor)) {
      types.push({ value: 'enrollment-reminder', label: 'Reminder to finalize enrollment ' });
    }

    if (['Programs', 'Online', 'Events', 'Parties'].includes(automationFor)) {
      types.push(
        { value: 'enrollment-confirmation', label: 'Enrollment Confirmation' },
        { value: 'reminder', label: 'Reminder (before start date)' },
        { value: 'onboarding', label: 'Onboarding (during start date)' }
      );
    }

    //Note: develop check-up later. Intended for organizer to send check-up emails to customers when they miss a class
    /*
     if (['Programs', 'Online'].includes(automationFor)) {
      types.push({ value: 'check-up', label: 'Check Up' });
    }
    */ 

    types.push({ value: 'follow-up', label: 'Follow Up' });

    if (automationFor === 'Memberships') {
      types.push({ value: 'milestone', label: 'Milestone' });
    }

    return types;
  };

  const getModalFields = () => {
    const communicationTypeField = {
      type: GET_HTML,
      data: {
        name: "Email or Text:",
        gethtml: () => (
          <div style={{ display: 'flex', alignItems: 'center'}}>
            <select
              value={communicationType}
              onChange={e => {
                setCommunicationType(e.target.value)
                setAutomationFor("");
                setAutomationType("");
                setTemplate("");
              }}
              style={{
                width: '100%',
                height: '38px',
                padding: '8px',
                border: '1px solid #ced4da',
                borderRadius: '4px',
                fontSize: '14px',
                color: '#666'
              }}
            >
              <option value="" style={{color: '#666'}}>Select communication type...</option>
              <option value="email" style={{color: '#666'}}>Email</option>
              <option value="text" style={{color: '#666'}}>Text Message</option>
            </select>
            <Icon 
              name="info circle" 
              style={{ 
                color: '#666',
                cursor: 'pointer',
                fontSize: '12px',
                marginLeft: '10px'
              }}
              title="Choose whether to send an email or text message."
            />
          </div>
        ),
        required: true
      },
      validators: { validateSubmit: () => communicationType !== "" }
    };
    const automationForField = {
      type: GET_HTML,
      data: {
        name: "Automation For:",
        gethtml: () => (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <select
              value={automationFor}
              onChange={e => {
                setAutomationFor(e.target.value)
                setAutomationType("");
                setTemplate("");
              }}
              disabled={!communicationType}
              style={{
                width: '100%',
                height: '38px',
                padding: '8px',
                border: '1px solid #ced4da',
                borderRadius: '4px',
                fontSize: '14px',
                color: '#666'
              }}
            >
              <option value="" style={{color: '#666'}}>Select listing type...</option>
              <option value="Programs" style={{color: '#666'}}>Programs</option>
              <option value="Online" style={{color: '#666'}}>Online Virtual</option>
              <option value="Events" style={{color: '#666'}}>Events</option>
              <option value="Parties" style={{color: '#666'}}>Parties</option>
              <option value="Memberships" style={{color: '#666'}}>Memberships</option>
              <option value="Giftcards" style={{color: '#666'}}>Giftcards</option>
            </select>
            <Icon 
              name="info circle" 
              style={{ 
                color: '#666',
                cursor: 'pointer',
                fontSize: '12px'
              }}
              title="Select the type of program this automation will apply to."
            />
          </div>
        ), 
        required: true
      },
      validators: { validateSubmit: () => automationFor !== "" }
    };
    const automationTypeField = {
        type: GET_HTML,
        data: {
          name: "Type:",
          gethtml: () => (
            <div style={{ display: 'flex', alignItems: 'center'}}>
              <select
                value={automationType}
                onChange={e => {
                  setAutomationType(e.target.value)
                  setTemplate("");
                }}
                disabled={!automationFor}
                style={{
                  width: '100%',
                  height: '38px',
                  padding: '8px',
                  border: '1px solid #ced4da',
                  borderRadius: '4px',
                  fontSize: '14px', 
                  color: '#666'
                }}
              >
                <option value="" style={{color: '#666'}}>Select automation type...</option>
                {getAvailableTypes(automationFor).map(type => (
                <option key={type.value} value={type.value} style={{color: '#666'}}>
                  {type.label}
                </option>
              ))}
              </select>
              <Icon 
                name="info circle" 
                style={{ 
                  color: '#666',
                  cursor: 'pointer',
                  fontSize: '12px',
                  marginLeft: '10px'
                }}
                title="Choose whether this is a reminder after enrollment, before the start date, or during the start date."
              />
            </div>
          ),
          required: true
        },
        validators: { validateSubmit: () => automationType !== "" }
      };
      const templateField = {
        type: GET_HTML,
        data: {
          name: "Template:",
          gethtml: () => (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <select
                value={template}
                onChange={e => {
                  setTemplate(e.target.value)
                }}
                disabled={!automationType}
                style={{
                  width: '100%',
                  height: '38px',
                  padding: '8px',
                  border: '1px solid #ced4da',
                  borderRadius: '4px',
                  fontSize: '14px',
                  color: '#666'
                }}
              >
                <option value="">Select template...</option>
                {templates
                .filter(t => t.type === communicationType)
                .map(t => (
                  <option key={t.id} value={t.id}>{t.title}</option>
                ))}
              </select>
              <Icon 
                name="info circle" 
                style={{ 
                  color: '#666',
                  cursor: 'pointer',
                  fontSize: '12px'
                }}
                title="Select the template that will be sent to customers."
              />
            </div>
          ),
          required: true
        },
        validators: { validateSubmit: () => template !== "" }
      };
      
    const timingField = {
        type: GET_HTML,
        data: {
            name:"Timing:",
            gethtml: () => {
                return (
                    <div className="form-group" style={{ marginBottom: 0 }}>
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: '8px',
                            height: '40px' 
                        }}>
                             
                            <input
                                type="number"
                                value={timing}
                                onChange={e => setTiming(e.target.value)}
                                placeholder=""
                                style={{
                                    width: '80px',
                                    height: '38px',
                                    padding: '8px',
                                    border: '1px solid #ced4da',
                                    borderRadius: '4px',
                                    fontSize: '14px'
                                }}
                            />
                            <div className="btn-group" role="group" aria-label="Time unit selection">
                                {['Hours', 'Days', 'Weeks'].map(unit => (
                                    <button
                                        key={unit}
                                        type="button"
                                        className={`btn ${timingUnit === unit ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => setTimingUnit(unit)}
                                        style={{
                                            padding: '8px 16px',
                                            fontSize: '14px',
                                            fontWeight: timingUnit === unit ? '600' : '400',
                                            borderColor: '#2880ff',
                                            backgroundColor: timingUnit === unit ? '#2880ff' : 'white',
                                            color: timingUnit === unit ? 'white' : '#2880ff'
                                        }}
                                    >
                                        {unit}
                                    </button>
                                ))}
                            </div>
                            <span style={{ marginLeft: '2px', color: '#666', fontSize: '20px' }}>
                                {automationType === "reminder" ? "Before" : "After"}
                            </span>
                            <Icon 
                                name="info circle" 
                                style={{ 
                                    color: '#666',
                                    cursor: 'pointer',
                                    fontSize: '12px'
                                }}
                                title={`Set the timing for the email to send ${automationType === "reminder" ? "before" : "after"} the ${automationType === 'enrollment-confirmation' ? "enrollment date" : "start date"}.`}
                            />
                           
                        </div>
                    </div>
                );
            }
        },
        validators: { validateSubmit: () => {
            if (!timing) return false;
            return validateTiming(timing);
        }}
    };
    return [communicationTypeField, automationForField, automationTypeField, templateField, timingField];
  };

  const getModalButtons = () => {
    const createButton = {
      name: "Confirm",
      buttonColour: BLUE_BUTTON,
      textColour: "#fff",
      handleClick: () => {
        
        console.log("Submitting with values:", {
          communicationType,
          automationType,
          templateId: template,
          timing,
          timingUnit,
          automationFor
        });
  
        onSubmit({
          ...(editAutomation && { id: editAutomation.id }), 
          automationType,
          templateId: template,
          timing,
          timingUnit,
          automationFor,
          communicationType
        });
      },
      validatorKey: "validateSubmit"
    };
    return [createButton];
  };

  const getModalProps = () => {
    return {
      title: editAutomation ? "Edit Automation" : "Create New Automation",
      fields: getModalFields(),
      buttons: getModalButtons(),
      height: "65vh",
      midSectionHeight: "52vh",
      handleClose: onClose
    };
  };

  return <BaseModal {...getModalProps()} />;
};

export default NewAutomationModal;
